var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "base-dialog",
        {
          attrs: {
            dontShowAgainCookie:
              _vm.SIMPLE_MICROHABIT_BLOCK_CLICK_DISCLAIMER_COOKIE,
            dontShowAgainCookieExpirationDays: 30
          },
          model: {
            value: _vm.disclaimerModalVisible,
            callback: function($$v) {
              _vm.disclaimerModalVisible = $$v
            },
            expression: "disclaimerModalVisible"
          }
        },
        [
          _c("p", [
            _vm._v(
              "\n\t\t\t" +
                _vm._s(
                  _vm.$t(
                    "microhabits.simple.panel-menu.on-block-click-disclaimer"
                  )
                ) +
                "\n\t\t"
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("MicrohabitsPanelMenu", {
        attrs: { type: _vm.MICROHABIT_SIMPLE_TYPE },
        on: { blockClick: _vm.onBlockClick }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-493a43ac", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-493a43ac","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/webapp/patient/microhabits/SimpleMicrohabitsPanelMenu.vue
// module id = 4192
// module chunks = 69